export const ERROR_MESSAGES = {
  somethingWentWrong:
    "Due to technical reasons we are not able to process your request at the moment, we will be back shortly.",
  sessionExpired: "Session expired",
  missingParams: "Missing required parameters",
};
